// graphqlQueries.ts

// export const INTAKE_IMAGES_QUERY = `
//   query IntakeImageUncategorized($fromDate: Date!, $toDate: Date!) {
//     intakeImageUncategorized(fromDate: $fromDate, toDate: $toDate) {
//       totalCount
//       images {
//         imageUrl
//         caption
//         uploadedByUsername
//         uploadedByFirstName
//         uploadedOn
//       }
//     }
//   }
// `;

export const INTAKE_IMAGES_QUERY = `query {
  intakeImageUncategorized {
    totalCount
    images {
      id
      imagePath
      imageUrl
      caption
      uploadedByUsername
      uploadedByFirstName
      uploadedOn
      azureFileId
    }
  }
}`;

const baseUrl = "https://haveblue-django.azurewebsites.net";
// const baseUrl = "https://lsdbhaveblueuat.azurewebsites.net";

export const fetchIntakeImagesUncategorized = async (
  authAxios: any,
  fromDate: string,
  toDate: string,
  uploadedBy?: string,
) => {
  const response = await authAxios.post(
    `${baseUrl}/graphql/intake-image-uncategorized/`,
    {
      query: INTAKE_IMAGES_QUERY,
      variables: { fromDate: fromDate, toDate: toDate },
    },
  );

  return response.data;
};
